module.exports = __webpack_public_path__ + "static/media/polymer-selected-24px.45300dec.svg";